import { Button, Container, Stack, Text } from "basis";
import { CreditCard } from "components/CreditCard/CreditCard";
import { Layout } from "components/Layout/Layout";
import { SvgInline } from "components/SvgInline/SvgInline";
import { useAccountInfo } from "library/hooks/useAccountInfo";
import { useNavigate } from "react-router";
import { useCliContext } from "../hooks/useCliContext";

export const PendingAcceptance = () => {
  const { state } = useCliContext();
  const accountInfo = useAccountInfo(state.account);
  const navigate = useNavigate();

  return (
    <Layout>
      <Layout.Header>Request a credit limit increase</Layout.Header>
      <Layout.Main>
        <Stack gap="8">
          <Container bg="grey.t05" padding="4">
            <CreditCard
              cardName={accountInfo?.cardName ?? ""}
              cardEndsWith={accountInfo?.cardEndsWith}
            />
          </Container>
          <SvgInline name="take-a-break" size="120" />
          <Text as="h3" textStyle="heading4">
            Thank you, your application is with us for review.
          </Text>
          <Text>We’ll be in contact via email within the next few days.</Text>
          <Button onClick={() => navigate("/manage-account")}>
            Manage account
          </Button>
        </Stack>
      </Layout.Main>
    </Layout>
  );
};
